// extracted by mini-css-extract-plugin
export default {"light":"Themes_light__0nRU+","dark":"Themes_dark__L9kXR"};